import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@doccareplus/shared/lib/theme'
import { NotFoundPage } from '@doccareplus/ui/NotFoundPage'
import { LandingPage, PrivacyPolicyPage, TermsOfServicePage } from '@features'

// doccareplus.com — the public marketing site. No auth, no Redux; its CTAs
// deep-link to the clinic panel and patient portal apps (see src/config.ts).
export function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="marketing-theme">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}
